// @core/api/endpoints/bootstrap/save_platform_mode.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SavePlatformModeRequest,
  SavePlatformModeResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Save platform mode
 * Saves the deployment mode selection (cloud or on-premise). Returns suggested defaults for subsequent steps based on the selected mode.
 * @public This endpoint does not require authentication
 */
export async function SavePlatformMode(
  data: SavePlatformModeRequest,
  options?: RequestOptions
): Promise<SavePlatformModeResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/steps/mode`;
  const requestOptions = { ...options, skipAuth: true };
  return client.put<SavePlatformModeResponse>(requestPath, data, requestOptions);
}
